import { METHOD } from './constants';

const BACKEND_BASE_URL = import.meta.env.VITE_BACKEND_BASE_URL;

const apis = {
  listAssignedAndProperProductsOfMart: {
    url: `${BACKEND_BASE_URL}/marts/v2/available/products/mart/`,
    method: METHOD.GET,
  },
  listAssignedAndProperProductsOfMartBySearch: {
    url: `${BACKEND_BASE_URL}/marts/`,
    method: METHOD.GET,
  },
  getNearestMart: {
    url: `${BACKEND_BASE_URL}/marts/nearest`,
    method: METHOD.GET,
  },
  getNearestNearbyLocation: {
    url: `${BACKEND_BASE_URL}/nearbyLocations/nearest`,
    method: METHOD.GET,
  },
  sendOtp: {
    url: `${BACKEND_BASE_URL}/users/sendOtp`,
    method: METHOD.POST,
  },
  verifyOtp: {
    url: `${BACKEND_BASE_URL}/users/verifyOtp`,
    method: METHOD.POST,
  },
  nearbyLocations: {
    url: `${BACKEND_BASE_URL}/nearbyLocations`,
    method: METHOD.GET,
  },
  getUserDetails: {
    url: `${BACKEND_BASE_URL}/users/getme`,
    method: METHOD.GET,
  },
  getUserAddresses: {
    url: `${BACKEND_BASE_URL}/userAddress`,
    method: METHOD.GET,
  },
  createUserAddress: {
    url: `${BACKEND_BASE_URL}/userAddress`,
    method: METHOD.POST,
  },
  updateUserAddress: {
    url: `${BACKEND_BASE_URL}/userAddress/`,
    method: METHOD.PUT,
  },
  deleteUserAddress: {
    url: `${BACKEND_BASE_URL}/userAddress/`,
    method: METHOD.DELETE,
  },
  getProductDetails: {
    url: `${BACKEND_BASE_URL}/stock/mart/`,
    method: METHOD.GET
  },
  getProductById: {
    url: `${BACKEND_BASE_URL}/products/id/`,
    method: METHOD.GET
  },
  updateUserFromUser: {
    url: `${BACKEND_BASE_URL}/users/updateUser`,
    method: METHOD.PUT
  },
  getUserOrders: {
    url: `${BACKEND_BASE_URL}/orders`,
    method: METHOD.GET
  },
  listCategory: {
    url: `${BACKEND_BASE_URL}/categories/list`,
    method: METHOD.GET,
  },
  getProductByCategory: {
    url: `${BACKEND_BASE_URL}/marts/products/`,
    method: METHOD.GET,
  },
  getMartDetails: {
    url: `${BACKEND_BASE_URL}/marts/`, // + martId
    method: METHOD.GET,
  },
  createOrder: {
    url: `${BACKEND_BASE_URL}/orders`,
    method: METHOD.POST,
  },
  updateOrder: {
    url: `${BACKEND_BASE_URL}/orders/`,
    method: METHOD.PUT,
  },
  getOrderDetails: {
    url: `${BACKEND_BASE_URL}/orders/`,
    method: METHOD.GET,
  },
  deleteAccount: {
    url: `${BACKEND_BASE_URL}/users/delete/me`,
    method: METHOD.DELETE,
  },
  createReturn: {
    url: `${BACKEND_BASE_URL}/returns`,
    method: METHOD.POST,
  },
  cancelReturn: {
    url: `${BACKEND_BASE_URL}/returns/`,
    method: METHOD.PATCH,
  },
  presignImageUpload: {
    url: `${BACKEND_BASE_URL}/s3/presignUpload`,
    method: METHOD.POST,
  },
  registerDeviceToken: {
    url: `${BACKEND_BASE_URL}/notifications/device-token`,
    method: METHOD.POST,
  },
  getConfig: {
    url: `${BACKEND_BASE_URL}/config`,
    method: METHOD.GET,
  },
  validatePromotion: {
    url: `${BACKEND_BASE_URL}/promotions/validate`,
    method: METHOD.POST,
  },
  membershipStats: {
    url: `${BACKEND_BASE_URL}/users/me/membership-stats`,
    method: METHOD.GET,
  },
};

export default apis;